export enum psetPropertyFileEnum {
  CODE_ACV = "ttb_code_acv",
  DESCRIPTION = "ttb_description",
  USAGES = "ttb_usages",
}
